import {
  DealItemWithVersions,
  ValidationError,
} from '@/lib/graphql/generated/graphql';
import type { ErrorLike } from '@apollo/client';
import { atom } from 'jotai';

export const productsMapState = atom<Map<string, DealItemWithVersions>>(
  new Map()
);

export const dealItemsLoadingState = atom<{
  initialLoading: boolean;
  error: ErrorLike | undefined;
}>({ initialLoading: true, error: undefined });

export const dealItemsStreamingState = atom<boolean>(false);

export const dealItemsRefetchState = atom<{
  fn: () => Promise<boolean>;
} | null>(null);

export const localValidationErrorsAtom = atom<Map<
  string,
  ValidationError[]
> | null>(null);

export const backendValidatedProductIdsAtom = atom<Set<string>>(
  new Set<string>()
);

export const productsState = atom(
  (get) => Array.from(get(productsMapState).values()),
  (
    _get,
    set,
    update:
      | DealItemWithVersions[]
      | ((prev: DealItemWithVersions[]) => DealItemWithVersions[])
  ) => {
    set(productsMapState, (prevMap) => {
      const newArray =
        typeof update === 'function'
          ? update(Array.from(prevMap.values()))
          : update;
      const nextMap = new Map<string, DealItemWithVersions>();
      for (const p of newArray) nextMap.set(p.id, p);
      return nextMap;
    });
  }
);
